import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditSourceDialogComponent } from './edit-source-dialog.component';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from 'src/app/app-material/app-material.module';

@NgModule({
  declarations: [EditSourceDialogComponent],
  imports: [AppMaterialModule, CommonModule, FormsModule],
  entryComponents: [EditSourceDialogComponent]
})
export class EditSourceDialogModule {}
